function getEnv(name: string): string {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export function getMissingSupabaseBrowserEnv(): string[] {
  const missing: string[] = [];
  if (!process.env.NEXT_PUBLIC_SUPABASE_URL) {
    missing.push('NEXT_PUBLIC_SUPABASE_URL');
  }
  if (!process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY) {
    missing.push('NEXT_PUBLIC_SUPABASE_ANON_KEY');
  }
  return missing;
}

export function isSupabaseBrowserEnvConfigured(): boolean {
  return getMissingSupabaseBrowserEnv().length === 0;
}

export function getSupabaseUrl(): string {
  const value = process.env.NEXT_PUBLIC_SUPABASE_URL;
  if (!value) {
    throw new Error('Missing required environment variable: NEXT_PUBLIC_SUPABASE_URL');
  }
  return value;
}

export function getSupabaseAnonKey(): string {
  const value = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
  if (!value) {
    throw new Error('Missing required environment variable: NEXT_PUBLIC_SUPABASE_ANON_KEY');
  }
  return value;
}

export function getSupabaseServiceRoleKey(): string {
  return getEnv('SUPABASE_SERVICE_ROLE_KEY');
}

export function getStripeSecretKey(): string {
  return getEnv('STRIPE_SECRET_KEY');
}

export function getStripeWebhookSecret(): string {
  return getEnv('STRIPE_WEBHOOK_SECRET');
}

export function getPublicStripeKey(): string {
  return getEnv('NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY');
}

export function getGoogleServiceAccountEmail(): string {
  return getEnv('GOOGLE_SERVICE_ACCOUNT_EMAIL');
}

export function getGoogleServiceAccountPrivateKey(): string {
  return getEnv('GOOGLE_SERVICE_ACCOUNT_PRIVATE_KEY').replace(/\\n/g, '\n');
}

export function getGoogleCalendarId(): string {
  return getEnv('GOOGLE_CALENDAR_ID');
}

export function getGoogleImpersonateUserEmail(): string | null {
  const value = process.env.GOOGLE_IMPERSONATE_USER_EMAIL?.trim();
  return value || null;
}
